/**
 * Initialize the LiveStream from environment variables.
 *
 * Expected env vars (PUBLIC_ prefix for SvelteKit dynamic public env):
 *   PUBLIC_APPSYNC_EVENTS_HTTP_ENDPOINT  - e.g. https://roast-stream.roastlog.com/event
 *   PUBLIC_APPSYNC_EVENTS_WS_ENDPOINT    - e.g. wss://roast-stream.roastlog.com
 *
 * The WS endpoint should be the base domain only (no path). If /event/realtime is included,
 * it will be stripped automatically since the client appends it.
 *
 * If either is missing, the live stream feature is silently disabled.
 */
import { env } from '$env/dynamic/public';
import logger from '$lib/logger';
import { liveStream } from './LiveStream';

export function initLiveStream() {
  const httpEndpoint = env.PUBLIC_APPSYNC_EVENTS_HTTP_ENDPOINT;
  let realtimeEndpoint = env.PUBLIC_APPSYNC_EVENTS_WS_ENDPOINT;

  if (!httpEndpoint || !realtimeEndpoint) {
    logger.info('LiveStream disabled: missing AppSync Events env vars');
    return;
  }

  // Strip /event/realtime suffix if present — the client appends it in #openSocket
  realtimeEndpoint = realtimeEndpoint.replace(/\/event\/realtime\/?$/, '');

  liveStream.configure({ httpEndpoint, realtimeEndpoint });
}
